import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5070632c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "当前被保人", -1))
const _hoisted_3 = { class: "top-inner-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "更改被保人", -1))
const _hoisted_5 = { class: "middle" }
const _hoisted_6 = { class: "middle-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "middle-item-title" }, "被保人类型", -1))
const _hoisted_8 = { class: "middle-item" }
const _hoisted_9 = { class: "middle-item-title" }
const _hoisted_10 = { class: "middle-item" }
const _hoisted_11 = { class: "middle-item-title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "更改被保人", -1))
const _hoisted_13 = { class: "bottom" }
const _hoisted_14 = { class: "middle-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "middle-item-title" }, "电话", -1))
const _hoisted_16 = { class: "middle-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "middle-item-title" }, "邮箱", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-title" }, "更改被保人后不会收到电话和邮箱通知", -1))

import AppHeader from '@/components/Header.vue'
import { RadioGroup, Radio, Field, Divider, Button, Toast, Dialog } from 'vant'
import { ref, onMounted, computed, withDefaults } from 'vue'
import { ComponentInstance } from 'vant/lib/utils'
import { getServiceList, batchPinganCorrectInformation } from '@/apis/three-liability-insurance'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { AxiosError } from 'axios'
import AppHost from '@/utils/app'


export default /*#__PURE__*/_defineComponent({
  __name: 'change-the-insured',
  props: {
    displayMode: { default: 'Portrait' }
  },
  setup(__props: any) {

const props = __props as { displayMode: string };

const onLeftClick = function () {
  AppHost.goAppBack()
}


let route = useRoute()
let router = useRouter()
const store = useStore()
console.log('store', store)
const updated_by = store.state.userInfo.realName
let sn = route.query.sn as string
let changeData = ref({
  policy_no: '',
  insurant_name: '',
  insurant_certi_no: '',
  insurant_type: 0,
  insurant_email: '',
  insurant_phone_no: '',
  insurant_certi_type: '',
})
let loading = ref(false)
const type = computed(() => {
  return changeData.value.insurant_type
})

const firstInputPlaceholder = computed(() => {
  return '请填写' + (type.value === 0 ? '正确的公司名称' : '真实姓名')
})

const secondInputPlaceholder = computed(() => {
  return '请填写' + (type.value === 0 ? '正确的统一信用代码' : '身份证号')
})

const name = ref('')
const IDNumber = ref('')

const personName = ref('')
const personIDNumber = ref('')

async function submit() {
  let changeDataOperator = changeData.value
  let data = {
    policy_no: changeDataOperator.policy_no,
    updated_by: updated_by,
    name: type.value === 0 ? name.value : personName.value,
    email: changeDataOperator.insurant_email,
    phone: changeDataOperator.insurant_phone_no,
    personnel_type: String(changeDataOperator.insurant_type),
    certificate_type: changeDataOperator.insurant_type === 0 ? '04' : '01',
    certificate_no: type.value === 0 ? IDNumber.value : personIDNumber.value,
  }
  loading.value = true
  try {
    await batchPinganCorrectInformation(data)
    loading.value = false
    Toast.success('更改成功')
    setTimeout(() => {
      router.go(-1)
    }, 2000)
  } catch (e) {
    // Toast.fail('更改失败')
    Toast.clear()
    Dialog.alert({ message: (e as AxiosError)?.message })
    // Toast.fail((e as AxiosError)?.message || '网络连接错误，请稍后再试')
    loading.value = false
  }
}
let flag = false
function radioChange() {
  if (flag) {
    name.value = ''
    IDNumber.value = ''
  }
  flag = true
}

onMounted(async () => {
  try {
    Toast.loading({
      message: `加载中...`,
      duration: 0,
    })
    let data = await getServiceList({ sn })
    changeData.value = data as any
    if (changeData.value.insurant_type === 0) {
      name.value = data.insurant_name
      IDNumber.value = data.insurant_certi_no
    } else {
      personName.value = data.insurant_name
      personIDNumber.value = data.insurant_certi_no
    }
    Toast.clear()
  } catch (e) {
    if ((e as { status: number }).status === 4304) {
      console.log('dd')
      Toast.fail('登录失效,请重新登录后再试')
    } else {
      Toast.fail((e as AxiosError)?.message || '网络连接错误，请稍后再试')
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "更改被保人",
      onLeftClick: onLeftClick
    }),
    _createElementVNode("div", {
      class: _normalizeClass(["content", props.displayMode === 'Landscape' ? 'landscape-width' : ''])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_unref(changeData).insurant_name), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(changeData).insurant_certi_no), 1)
        ])
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_unref(RadioGroup), {
            style: { height: '24px' },
            modelValue: _unref(changeData).insurant_type,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(changeData).insurant_type) = $event)),
            direction: "horizontal",
            "checked-color": "#02c37b",
            class: "xa-radio-group"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Radio), { name: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode("个人")
                ]),
                _: 1
              }),
              _createVNode(_unref(Radio), { name: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode("公司")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode(_unref(Divider), { style: { padding: '0 0', margin: '0 0' } }),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(type) === 0 ? '公司名称' : '真实姓名'), 1),
          _withDirectives(_createVNode(_unref(Field), {
            style: {"font-size":"16px","line-height":"24px"},
            modelValue: name.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((name).value = $event)),
            modelModifiers: { trim: true },
            placeholder: _unref(firstInputPlaceholder)
          }, null, 8, ["modelValue", "placeholder"]), [
            [_vShow, _unref(type) === 0]
          ]),
          _withDirectives(_createVNode(_unref(Field), {
            style: {"font-size":"16px","line-height":"24px"},
            modelValue: personName.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((personName).value = $event)),
            modelModifiers: { trim: true },
            placeholder: _unref(firstInputPlaceholder)
          }, null, 8, ["modelValue", "placeholder"]), [
            [_vShow, _unref(type) === 1]
          ])
        ]),
        _createVNode(_unref(Divider), { style: { padding: '0 0', margin: '0 0' } }),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(type) === 0 ? '统一社会信用代码' : '身份证号'), 1),
          _withDirectives(_createVNode(_unref(Field), {
            style: {"font-size":"16px","line-height":"24px"},
            modelValue: IDNumber.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((IDNumber).value = $event)),
            modelModifiers: { trim: true },
            placeholder: _unref(secondInputPlaceholder)
          }, null, 8, ["modelValue", "placeholder"]), [
            [_vShow, _unref(type) === 0]
          ]),
          _withDirectives(_createVNode(_unref(Field), {
            style: {"font-size":"16px","line-height":"24px"},
            modelValue: personIDNumber.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((personIDNumber).value = $event)),
            modelModifiers: { trim: true },
            placeholder: _unref(secondInputPlaceholder)
          }, null, 8, ["modelValue", "placeholder"]), [
            [_vShow, _unref(type) === 1]
          ])
        ])
      ]),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_unref(Field), {
            style: {"font-size":"16px","line-height":"24px"},
            modelValue: _unref(changeData).insurant_phone_no,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(changeData).insurant_phone_no) = $event)),
            modelModifiers: { trim: true },
            placeholder: "请填写联系电话"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_unref(Divider), { style: { padding: '0 0', margin: '0 0' } }),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_unref(Field), {
            style: {"font-size":"16px","line-height":"24px"},
            modelValue: _unref(changeData).insurant_email,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(changeData).insurant_email) = $event)),
            modelModifiers: { trim: true },
            placeholder: "请填写邮箱"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _hoisted_18,
      _createVNode(_unref(Button), {
        color: "#02c37b",
        style: {
        width: '100%',
        height: '48px',
        background: '#00C378',
        borderRadius: '8px',
        footWeight: 500,
        fontSize: '16px',
        lineHeight: '24px',
      },
        onClick: submit,
        "loading-type": "spinner",
        loading: _unref(loading),
        "loading-text": "请稍候"
      }, {
        default: _withCtx(() => [
          _createTextVNode("提交")
        ]),
        _: 1
      }, 8, ["loading"])
    ], 2)
  ], 64))
}
}

})